import { useCallback, useEffect, useState } from 'react';
import { OtpChannel, OtpRequestChannelType } from '../_types/otp.types';
import { otpRequestChannelTypeMapper, ValidationChannelConfig } from '../../../utils/otpRequestChannelTypeMapper';

interface UseValidationChannelsProps {
  otpRequestChannelType: OtpRequestChannelType;
  userData: {
    phoneNumber?: string;
    email?: string;
  };
  onChannelSelect: (channel: OtpChannel) => void;
  onOptionsCountChange: (count: number) => void;
}

export const useOtpRequestChannelType = ({
                                           otpRequestChannelType,
                                           userData,
                                           onChannelSelect,
                                           onOptionsCountChange
                                         }: UseValidationChannelsProps) => {
  const [config, setConfig] = useState<ValidationChannelConfig>({channels: []});
  const [selectedChannel, setSelectedChannel] = useState<OtpChannel | undefined>();
  
  useEffect(() => {
    const newConfig = otpRequestChannelTypeMapper.getAvailableChannels(otpRequestChannelType, userData);
    setConfig(newConfig);
    
    onOptionsCountChange(newConfig.channels.length);
    
    const isChannelSelected = selectedChannel && newConfig.channels.some(c => c.value === selectedChannel);
    
    if (newConfig.defaultChannel && newConfig.channels.length > 0 && !isChannelSelected) {
      setSelectedChannel(newConfig.defaultChannel);
      onChannelSelect(newConfig.defaultChannel);
    }
  }, [otpRequestChannelType, userData, onChannelSelect, onOptionsCountChange, selectedChannel]);
  
  const handleChannelSelect = useCallback((channel: OtpChannel) => {
    setSelectedChannel(channel);
    onChannelSelect(channel);
  }, [onChannelSelect]);
  
  const getSecurityQuestion = useCallback(() => otpRequestChannelTypeMapper.getSecurityCodeQuestion(config.channels.length), [config.channels.length]);
  
  return {
    channels: config.channels,
    selectedChannel,
    hasChannels: config.channels.length > 0,
    channelsCount: config.channels.length,
    handleChannelSelect,
    getSecurityQuestion
  };
};
